import React,{useState} from 'react';
import {Link,useLocation} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMenu,FiX}=FiIcons;

const Header=()=> {
const [isMenuOpen,setIsMenuOpen]=useState(false);
const location=useLocation();
const navigation=[
 {name: 'Home',path: '/'},{name: 'Services',path: '/services'},{name: 'Menu Gallery',path: '/menu-gallery'},{name: 'About Us',path: '/about'},{name: 'Contact Us',path: '/contact'}
 ];
const isActive=(path)=> location.pathname===path;

return (
 <header className="bg-white shadow-lg sticky top-0 z-50">
 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
 <div className="flex justify-between items-center h-16">
 {/* Logo */}
 <Link to="/" className="flex items-center space-x-2">
 <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center">
 <span className="text-white font-bold text-xl">T</span>
 </div>
 <span className="text-xl font-bold text-gray-900">Tung Hing Bakery</span>
 </Link>
 {/* Desktop Navigation */}
 <nav className="hidden md:flex space-x-8"> {navigation.map((item)=> ( <Link key={item.name} to={item.path} className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive(item.path) ? 'text-red-500 bg-red-50' : 'text-gray-700 hover:text-red-500 hover:bg-red-50'}`} > {item.name} </Link> ))} </nav>
 {/* Mobile Menu Button */}
 <button onClick={()=> setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 rounded-md text-gray-700 hover:text-red-500 hover:bg-red-50" > <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" /> </button>
 </div>
 {/* Mobile Navigation */}
 {isMenuOpen && ( <motion.div initial={{opacity: 0,y: -10}} animate={{opacity: 1,y: 0}} exit={{opacity: 0,y: -10}} className="md:hidden bg-white border-t border-gray-200" > <nav className="px-2 pt-2 pb-3 space-y-1"> {navigation.map((item)=> ( <Link key={item.name} to={item.path} onClick={()=> setIsMenuOpen(false)} className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${isActive(item.path) ? 'text-red-500 bg-red-50' : 'text-gray-700 hover:text-red-500 hover:bg-red-50'}`} > {item.name} </Link> ))} </nav> </motion.div> )} </div>
 </header>
 );
};

export default Header;